import ActionTypes from './action-types';
import axios from 'axios';
import { firebaseDb, firebaseAuth } from 'src/firebase';

// add to waitlist
export function addToWaitlist(email, type) {
  return dispatch => {
    let hash = hashCode(email)
    firebaseDb.ref('user/' + hash).set({ 'email': email, 'type': type }).then( (response) => {
      dispatch(addToWaitlistFulfilledAction({email}))
    }).catch( (error) => {
      console.log(error)
      dispatch(addToWaitlistRejectedAction())
    });
  }
}

function hashCode (str){
    var hash = 0;
    if (str.length == 0) return hash;
    for (var i = 0; i < str.length; i++) {
        var char = str.charCodeAt(i);
        var hash = ((hash<<5)-hash)+char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}

function addToWaitlistRequestedAction() {
  return {
    type: ActionTypes.AddToWaitlistRequested
  };
}

function addToWaitlistRejectedAction() {
  return {
    type: ActionTypes.AddToWaitlistRejected
  }
}

function addToWaitlistFulfilledAction(payload) {
  return {
    type: ActionTypes.AddToWaitlistFulfilled,
    email: payload.email,
    waitlistSuccess: true
  };
}

// fetch waitcount
export function fetchUserCount() {
  return dispatch => {
    firebaseAuth.signInWithEmailAndPassword('test6@example.com', 'youtube').then( () => {
      var ref = firebaseDb.ref('user_count');
      ref.once('value')
      .then( (snapshot) => {
        let user_count = snapshot.val()
        dispatch(fetchUserCountResponse(user_count))
      })
      .catch( (error) => {
        console.log(error)
        dispatch(fetchUserCountResponse(0))
      });
    }).catch((error) => {
      console.log(error)
      dispatch(fetchUserCountResponse(0))
    });
  }
}

function fetchUserCountResponse(userCount) {
  return {
    waitlistCount: userCount,
    type: ActionTypes.WaitlistCountFetched
  }
}

// add user waitcount

export function addToUserCount() {
  return dispatch => {
    var ref = firebaseDb.ref('user_count');
    ref.once('value')
    .then( (snapshot) => {
      let user_count = snapshot.val()
      firebaseDb.ref().update({'user_count': user_count + 1}).then( (response) => {
        dispatch(addToUserCountSuccessful(response))
      }).catch( (error) => {
        console.log(error)
        dispatch(addToUserCountFailure(error))
      });
    }).catch( (error) => {
      console.log(error)
      dispatch(addToUserCountFailure(error))
    });
  }
}

function addToUserCountFailure(error) {
  return {
    error: error,
    type: ActionTypes.WaitlistUserCountAddSuccessful
  }
}

function addToUserCountSuccessful(response) {
  return {
    response: response,
    type: ActionTypes.WaitlistUserCountAddFailed
  }
}



// WEBPACK FOOTER //
// ./src/waitlist/actions.js